export const visitForm = {
    mainInfo: {
        title: {
            mandatory: true,
            value: '',
        },
        info: {
            value: null,
        },
        storeId: {
            value: null,
            mandatory: true
        },
        attachmentList: {
            value: [],
        },
    },
    pointsAssignment: {
        badge: {
            value: null,
            mandatory: true,
        },
        points: {
            value: null,
            mandatory: true,
        },
    },
    scheduling: {
        startDate: {
            value: null,
            mandatory: true,
        },
        startTime: {
            value: null,
            mandatory: true,
        },
        
        endTime: {
            value: null,
            mandatory: true,
        },
        calendarVisibility: {
            value: true,
        },
        remoteVisit: {
            value: false,
        },
        mysteryVisit: {
            value: false,
        },
    },
}
